"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.buildList = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _create2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/create"));

var _m = require("@mutant-ws/m");

var _create3 = require("./create/create");

var _create4 = require("./create/create.reducers");

var _read2 = require("./read/read");

var _read3 = require("./read/read.reducers");

var _readOne2 = require("./read-one/read-one");

var _readOne3 = require("./read-one/read-one.reducers");

var _update2 = require("./update/update");

var _update3 = require("./update/update.reducers");

var _remove2 = require("./remove/remove");

var _remove3 = require("./remove/remove.reducers");

var _queue = require("./lib/queue");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context7; (0, _forEach.default)(_context7 = ownKeys(Object(source))).call(_context7, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var debug = require("debug")("ReduxList:Main");

var collections = (0, _create2.default)(null);
/**
 * Construct a set of actions and reducers to manage a state slice as an array
 *
 * @param {string}   name     Unique name so actions dont overlap
 * @param {Object}   methods  Object with CRUD method
 * @param {Object}   hooks    Transformer functions called when specific actions
 *                            occur
 * @param {Function} onChange Function triggered on every list change
 *
 * @return {Object}
 */

var buildList = function buildList() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      _create = _ref.create,
      _read = _ref.read,
      _readOne = _ref.readOne,
      _update = _ref.update,
      _remove = _ref.remove,
      onChange = _ref.onChange;

  if ((0, _m.isEmpty)(name)) {
    throw new Error("ReduxList: \"name\" property is required, received \"".concat((0, _stringify.default)(name), "\""));
  }

  if ((0, _m.hasKey)(name)(collections)) {
    throw new Error("ReduxList: List with name \"".concat(name, "\" already exists"));
  }

  collections[name] = true;
  var props = {
    dispatch: null,
    createHasDispatchStart: true,
    createHasDispatchEnd: true,
    readHasDispatchStart: true,
    readHasDispatchEnd: true,
    readOneHasDispatchStart: true,
    readOneHasDispatchEnd: true,
    updateHasDispatchStart: true,
    updateHasDispatchEnd: true,
    removeHasDispatchStart: true,
    removeHasDispatchEnd: true
  };
  var queue = (0, _queue.buildQueue)();
  var createStart = "".concat(name, "_CREATE_START");
  var createEnd = "".concat(name, "_CREATE_END");
  var createError = "".concat(name, "_CREATE_ERROR");
  var readStart = "".concat(name, "_READ_START");
  var readEnd = "".concat(name, "_READ_END");
  var readError = "".concat(name, "_READ_ERROR");
  var readOneStart = "".concat(name, "_READ-ONE_START");
  var readOneEnd = "".concat(name, "_READ-ONE_END");
  var readOneError = "".concat(name, "_READ-ONE_ERROR");
  var updateStart = "".concat(name, "_UPDATE_START");
  var updateEnd = "".concat(name, "_UPDATE_END");
  var updateError = "".concat(name, "_UPDATE_ERROR");
  var removeStart = "".concat(name, "_REMOVE_START");
  var removeEnd = "".concat(name, "_REMOVE_END");
  var removeError = "".concat(name, "_REMOVE_ERROR");
  return {
    name: name,
    set: function set(source) {
      props = _objectSpread(_objectSpread({}, props), source);
    },
    create: function create(data) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$isLocal = _ref2.isLocal,
          isLocal = _ref2$isLocal === void 0 ? false : _ref2$isLocal,
          options = (0, _objectWithoutProperties2.default)(_ref2, ["isLocal"]);

      if (isLocal === false && typeof _create !== "function") {
        var _context;

        throw new TypeError((0, _concat.default)(_context = "ReduxList: \"".concat(name, "\".\"create\" must be a function, got \"")).call(_context, (0, _typeof2.default)(_create), "\""));
      }

      if (isLocal) {
        props.dispatch({
          type: createEnd,
          payload: {
            listName: name,
            items: (0, _isArray.default)(data) ? data : [data],
            onChange: onChange
          }
        });
        return _promise.default.resolve({
          result: data
        });
      }

      return queue.enqueue({
        id: "".concat(name, "__create"),
        fn: (0, _create3.createAction)({
          listName: name,
          dispatch: props.dispatch,
          api: _create,
          hasDispatchStart: props.createHasDispatchStart,
          hasDispatchEnd: props.createHasDispatchEnd,
          onChange: onChange
        }),
        // queue calls fn(...args)
        args: [data, _objectSpread({
          isLocal: isLocal
        }, options)]
      });
    },
    read: function read(query, options) {
      if (typeof _read !== "function") {
        var _context2;

        throw new TypeError((0, _concat.default)(_context2 = "ReduxList: \"".concat(name, "\".\"read\" must be a function, got \"")).call(_context2, (0, _typeof2.default)(_read), "\""));
      }

      return queue.enqueue({
        id: "".concat(name, "__read"),
        fn: (0, _read2.readAction)({
          listName: name,
          dispatch: props.dispatch,
          api: _read,
          hasDispatchStart: props.readHasDispatchStart,
          hasDispatchEnd: props.readHasDispatchEnd,
          onChange: onChange
        }),
        // queue calls fn(...args)
        args: [query, options]
      });
    },
    readOne: function readOne(query, options) {
      if (typeof _readOne !== "function") {
        var _context3;

        throw new TypeError((0, _concat.default)(_context3 = "ReduxList: \"".concat(name, "\".\"readOne\" must be a function, got \"")).call(_context3, (0, _typeof2.default)(_readOne), "\""));
      }

      return queue.enqueue({
        id: "".concat(name, "__readOne"),
        fn: (0, _readOne2.readOneAction)({
          listName: name,
          dispatch: props.dispatch,
          api: _readOne,
          hasDispatchStart: props.readOneHasDispatchStart,
          hasDispatchEnd: props.readOneHasDispatchEnd,
          onChange: onChange
        }),
        // queue calls fn(...args)
        args: [query, options]
      });
    },
    update: function update(id, data) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref3$isLocal = _ref3.isLocal,
          isLocal = _ref3$isLocal === void 0 ? false : _ref3$isLocal,
          onMerge = _ref3.onMerge,
          options = (0, _objectWithoutProperties2.default)(_ref3, ["isLocal", "onMerge"]);

      if (isLocal === false && typeof _update !== "function") {
        var _context4;

        throw new TypeError((0, _concat.default)(_context4 = "ReduxList: \"".concat(name, "\".\"update\" must be a function, got \"")).call(_context4, (0, _typeof2.default)(_update), "\""));
      }

      if (isLocal) {
        props.dispatch({
          type: updateEnd,
          payload: {
            listName: name,
            item: _objectSpread({
              id: id
            }, data),
            onMerge: onMerge,
            onChange: onChange
          }
        });
        return _promise.default.resolve({
          result: _objectSpread({
            id: id
          }, data)
        });
      }

      return queue.enqueue({
        id: "".concat(name, "__update"),
        fn: (0, _update2.updateAction)({
          listName: name,
          dispatch: props.dispatch,
          api: _update,
          hasDispatchStart: props.updateHasDispatchStart,
          hasDispatchEnd: props.updateHasDispatchEnd,
          onMerge: onMerge,
          onChange: onChange
        }),
        // queue calls fn(...args)
        args: [id, data, options]
      });
    },
    remove: function remove(id) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$isLocal = _ref4.isLocal,
          isLocal = _ref4$isLocal === void 0 ? false : _ref4$isLocal,
          options = (0, _objectWithoutProperties2.default)(_ref4, ["isLocal"]);

      if (isLocal === false && typeof _remove !== "function") {
        var _context5;

        throw new TypeError((0, _concat.default)(_context5 = "ReduxList: \"".concat(name, "\".\"remove\" must be a function, got \"")).call(_context5, (0, _typeof2.default)(_remove), "\""));
      }

      if (isLocal) {
        props.dispatch({
          type: removeEnd,
          payload: {
            listName: name,
            item: {
              id: id
            },
            onChange: onChange
          }
        });
        return _promise.default.resolve({
          result: {
            id: id
          }
        });
      }

      return queue.enqueue({
        id: "".concat(name, "__remove"),
        fn: (0, _remove2.removeAction)({
          listName: name,
          dispatch: props.dispatch,
          api: _remove,
          hasDispatchStart: props.removeHasDispatchStart,
          hasDispatchEnd: props.removeHasDispatchEnd,
          onChange: onChange
        }),
        // queue calls fn(...args)
        args: [id, _objectSpread({
          isLocal: isLocal
        }, options)]
      });
    },
    clear: function clear() {
      props.dispatch({
        type: readEnd,
        payload: {
          items: [],
          shouldClear: true
        }
      });
      return _promise.default.resolve([]);
    },
    reducer: function reducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        reading: null,
        creating: [],
        updating: [],
        removing: [],
        errors: {
          read: null,
          readOne: null,
          create: null,
          remove: null,
          update: null
        },
        loadDate: null,
        isLoading: false
      };

      var _ref5 = arguments.length > 1 ? arguments[1] : undefined,
          type = _ref5.type,
          payload = _ref5.payload;

      switch (type) {
        // Create
        case createStart:
          return (0, _create4.startReducer)(state, payload);

        case createEnd:
          return (0, _create4.endReducer)(state, payload);

        case createError:
          return (0, _create4.errorReducer)(state, payload);
        // Read

        case readStart:
          return (0, _read3.startReducer)(state, payload);

        case readEnd:
          return (0, _read3.endReducer)(state, payload);

        case readError:
          return (0, _read3.errorReducer)(state, payload);
        // ReadOne

        case readOneStart:
          return (0, _readOne3.startReducer)(state, payload);

        case readOneEnd:
          return (0, _readOne3.endReducer)(state, payload);

        case readOneError:
          return (0, _readOne3.errorReducer)(state, payload);
        // Update

        case updateStart:
          return (0, _update3.startReducer)(state, payload);

        case updateEnd:
          return (0, _update3.endReducer)(state, payload);

        case updateError:
          return (0, _update3.errorReducer)(state, payload);
        // Delete

        case removeStart:
          return (0, _remove3.startReducer)(state, payload);

        case removeEnd:
          return (0, _remove3.endReducer)(state, payload);

        case removeError:
          return (0, _remove3.errorReducer)(state, payload);

        default:
          return state;
      }
    },
    selector: function selector(state) {
      return {
        head: function head() {
          return (0, _m.get)([name, "items", 0])(state);
        },
        byId: function byId(id, notFoundDefault) {
          return (0, _m.pipe)((0, _m.get)([name, "items"]), (0, _m.findWith)({
            id: id
          }, notFoundDefault))(state);
        },
        items: function items() {
          return (0, _m.get)([name, "items"])(state);
        },
        creating: function creating() {
          return (0, _m.get)([name, "creating"])(state);
        },
        updating: function updating() {
          return (0, _m.get)([name, "updating"])(state);
        },
        removing: function removing() {
          return (0, _m.get)([name, "removing"])(state);
        },
        error: function error(action) {
          return (0, _m.get)([name, "errors", action])(state);
        },
        hasWithId: function hasWithId(id) {
          return (0, _m.pipe)((0, _m.get)([name, "items"]), (0, _m.hasWith)({
            id: id
          }))(state);
        },
        isCreating: function isCreating() {
          return !(0, _m.pipe)((0, _m.get)([name, "creating"]), _m.isEmpty)(state);
        },
        isRemoving: function isRemoving(id) {
          var removing = (0, _m.get)([name, "removing"])(state);
          return (0, _m.is)(id) ? (0, _m.hasWith)({
            id: id
          })(removing) : !(0, _m.isEmpty)(removing);
        },
        isUpdating: function isUpdating(id) {
          var updating = (0, _m.get)([name, "updating"])(state);
          return (0, _m.is)(id) ? (0, _m.hasWith)({
            id: id
          })(updating) : !(0, _m.isEmpty)(updating);
        },
        isLoading: function isLoading() {
          return (0, _m.get)([name, "isLoading"])(state);
        },
        isLoaded: function isLoaded() {
          return (0, _m.pipe)((0, _m.get)([name, "loadDate"]), _m.is)(state);
        }
      };
    }
  };
};

exports.buildList = buildList;